import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Col, Form, Media, Image, Row, Card, Button, Badge, ResponsiveEmbed } from "react-bootstrap";
import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import ReactPlayer from "react-player/lazy";
import {
  fetchSingleEventStart
} from "../../store/actions/EventAction";
import "./EventDetails.css";
import moment from "moment";
import LandingLayout from "../LandingPages/LandingLayout";

const EventDetails = (props) => {
  const isLoggedIn = !!localStorage.getItem("userId");

  useEffect(() => {
    props.dispatch(fetchSingleEventStart({ event_id: props.match.params.id }));
  }, []);

  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  function formatSmartTime(minutes) {
    if (minutes >= 60) {
      const hrs = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return mins > 0 ? `${hrs} hours ${mins} minutes` : `${hrs} hours`;
    } else {
      return `${minutes} minutes`;
    }
  }

  if (!isLoggedIn) {
    return (
      <LandingLayout title={`${props.singleEvent.data?.title || "Event Details"} | Rebel`}>
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="breadcrumbs">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/events">Events</Link>
              <span>›</span>
              <span>{props.singleEvent.data?.title || "Details"}</span>
            </div>

            <p className="page-label">{props.singleEvent.data?.event_category || "LIVE EVENT"}</p>
            <h1>{props.singleEvent.data?.title || "Event Details"}</h1>
            <p className="hero-description">
              {moment(props.singleEvent.data?.start_datetime).format("dddd, MMMM DD, YYYY · h:mm A")}
            </p>
          </div>
        </section>

        <section className="event-details-shell">
          {props.singleEvent.loading ? (
            <div className="text-center py-5" style={{ color: "#d9a6ff", fontSize: "1.2rem" }}>
              {t("loading")}
            </div>
          ) : !isEmpty(props.singleEvent.data) ? (
            <div className="event-details-grid">
              {/* Left Column */}
              <div>
                <article className="event-details-card">
                  {props.singleEvent.data?.event_video ? (
                    <ResponsiveEmbed aspectRatio="16by9" className="mb-4">
                      <ReactPlayer
                        url={props.singleEvent.data?.event_video}
                        playing={true}
                        muted={true}
                        loop={true}
                        controls={true}
                        playsinline
                        width="100%"
                        height="100%"
                      />
                    </ResponsiveEmbed>
                  ) : (
                    <img
                      src={props.singleEvent.data?.event_image}
                      alt={props.singleEvent.data?.title}
                      style={{ width: "100%", borderRadius: "12px", marginBottom: "24px", maxHeight: "450px", objectFit: "cover" }}
                    />
                  )}

                  <h2>About the Event</h2>
                  <div
                    className="event-desc"
                    dangerouslySetInnerHTML={{ __html: props.singleEvent.data?.description }}
                  />
                </article>

                {props.singleEvent.data?.terms_condition && (
                  <article className="event-details-card">
                    <h3>Terms & Conditions</h3>
                    <div
                      className="term-cond"
                      dangerouslySetInnerHTML={{ __html: props.singleEvent.data?.terms_condition }}
                    />
                  </article>
                )}
              </div>

              {/* Right Sidebar */}
              <aside>
                <div className="event-details-sidebar sticky" style={{ position: "sticky", top: "100px" }}>
                  {props.singleEvent.data?.event_video && (
                    <img
                      className="event-sidebar-img"
                      src={props.singleEvent.data?.event_image}
                      alt={props.singleEvent.data?.title}
                      style={{ width: "100%", borderRadius: "10px", marginBottom: "18px" }}
                    />
                  )}

                  <h4 className="event-overview-heading">Event Overview</h4>

                  <div className="event-sidebar-meta">
                    <div className="meta-row">
                      <i className="fas fa-calendar-alt fa" />
                      <div>
                        <strong>Date & Time</strong>
                        <div>{moment(props.singleEvent.data.start_datetime).format("ddd, MMM DD YYYY · h:mm A")}</div>
                      </div>
                    </div>

                    {props.singleEvent.data?.duration_minutes > 0 && (
                      <div className="meta-row">
                        <i className="fas fa-hourglass-half fa" />
                        <div>
                          <strong>Duration</strong>
                          <div>{formatSmartTime(props.singleEvent.data?.duration_minutes)}</div>
                        </div>
                      </div>
                    )}

                    <div className="meta-row">
                      <i className="fas fa-tags fa" />
                      <div>
                        <strong>Category</strong>
                        <div>{props.singleEvent.data?.event_category}</div>
                      </div>
                    </div>

                    <div className="meta-row">
                      <i className="fas fa-map-marker-alt fa" />
                      <div>
                        <strong>Location</strong>
                        <div>{props.singleEvent.data?.venue}</div>
                      </div>
                    </div>
                  </div>

                  <hr className="event-sidebar-divider" style={{ borderColor: "rgba(255,255,255,0.1)", margin: "10px 0" }} />

                  <div className="event-sidebar-booking-box" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <span style={{ fontSize: "0.8rem", color: "var(--muted)" }}>Ticket Price</span>
                      <div style={{ fontSize: "1.8rem", fontWeight: "800", color: "#ff4bb0" }}>
                        ${props.singleEvent.data?.ticket_price}
                      </div>
                    </div>

                    <Link
                      to={`/signup?redirect=${encodeURIComponent(`/checkout/${props.singleEvent.data?.id}`)}&context=event`}
                      className="button btn button-gradient btn-gradient"
                      style={{ border: "0px !important" }}
                    >
                      Buy Now
                    </Link>
                  </div>

                  {props.singleEvent.data?.show_remaining_tickets == 1 && (
                    <div className="event-sidebar-remaining-tickets" style={{ color: "#ff607f", fontSize: "0.85rem", fontWeight: "600", textAlign: "center" }}>
                      {props.singleEvent.data?.remaining_tickets > 0
                        ? `${props.singleEvent.data?.remaining_tickets} Tickets Left`
                        : "Sold Out"}
                    </div>
                  )}
                </div>
              </aside>
            </div>
          ) : (
            <div className="text-center py-5" style={{ color: "#b9b6cb" }}>
              <h3>{t("event_details_not_exist")}</h3>
            </div>
          )}
        </section>
      </LandingLayout>
    );
  }

  return (
    <>
      <div className="notification-page">
        <Container>
          <div className="profile-post-area">
            <div className="bookmarkes-list bookmarks-right-side resp-sapce-center">
              <div className="pull-left">
                <Link className="bookmarkes-list notify-title" to={`/events`}>
                  <Image
                    src="/assets/images/icons/back.svg"
                    className="svg-clone mr-3"
                  />
                  Event Details
                </Link>
              </div>
            </div>
          </div>
          {props.singleEvent.loading
            ? t("loading") : (!isEmpty(props.singleEvent.data))
              ? (
                <Row className="mb-5">
                  {/* Left: Event Details */}
                  <Col md={8} sm={12} lg={8} xl={8}>
                    <Card className="event-detail-card mb-4">
                      <Card.Body>
                        <h2 className="event-detail-title">{props.singleEvent.data?.title}</h2>
                      </Card.Body>
                      {props.singleEvent.data?.event_video != "" && props.singleEvent.data?.event_video != null ?
                        <>
                          {/* Responsive video wrapper */}
                          <ResponsiveEmbed aspectRatio="16by9">
                            <ReactPlayer
                              // light={
                              //   props.singleEvent.data?.event_video
                              // }
                              url={
                                props.singleEvent.data?.event_video
                              }
                              playing={true}
                              muted={true}      // 🔑 must for autoplay
                              loop={true}
                              controls={true}
                              playsinline
                              width="100%"
                              height="100%"
                              className="post-video-size"
                              config={{
                                file: {
                                  attributes: { controlsList: "nodownload" },
                                },
                              }}
                            />
                          </ResponsiveEmbed ></>
                        : <Card.Img variant="top" src={props.singleEvent.data?.event_image} className="event-main-img" />}

                      <Card.Body>
                        <h3 className="mt-3">About the Event</h3>
                        <div
                          key={"idx"}
                          className="term-cond mb-3 event-desc"
                          dangerouslySetInnerHTML={{ __html: props.singleEvent.data?.description }}
                        />
                      </Card.Body>
                    </Card>

                    <Card className="event-detail-card mm-2">
                      <Card.Body>
                        <h3>Terms & Conditions</h3>
                        <div
                          key={"idx"}
                          className="term-cond mb-3"
                          dangerouslySetInnerHTML={{ __html: props.singleEvent.data?.terms_condition }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Right: Sidebar */}
                  <Col md={4} sm={12} lg={4} xl={4}>
                    <Card className="event-sidebar">
                      <Card.Body>
                        {props.singleEvent.data?.event_video != "" && props.singleEvent.data?.event_video != null &&
                          <Card.Img variant="top" src={props.singleEvent.data?.event_image} className="event-main-img mb-4" />}
                        <h4 className="mb-3">Event Details</h4>
                        <p>
                          <i className="fas fa-lg fa-calendar-alt mr-3" />
                          <span className="meta-text">{moment(props.singleEvent.data.start_datetime).format("ddd, MMM DD YYYY")}</span>
                        </p>
                        <p>
                          <i className="fas fa-lg fa-clock mr-3" />
                          <span className="meta-text">
                            {moment(props.singleEvent.data.start_datetime).format("h:mm A")}</span>
                        </p>
                        <p>
                          <i className="fas fa-hourglass-half mr-3 fa-lg" />  <span className="meta-text">{formatSmartTime(props.singleEvent.data?.duration_minutes)}</span>
                        </p>
                        <p>
                          <i className="fas fa-tags mr-3" />
                          <span className="meta-text">{props.singleEvent.data?.event_category}</span>
                        </p>
                        <p className="d-flex">
                          <i className="fas fa-lg fa-map-marker-alt mr-4 mt-2" />
                          <span className="meta-text">{props.singleEvent.data?.venue}</span>
                        </p>
                        <hr />
                        <div className="d-flex justify-content-between align-items-end">
                          <p className="event-price-detail">
                            <span className="text-primary">{"$" + props.singleEvent.data?.ticket_price}</span>
                          </p>
                          <div>
                            {localStorage.getItem("userId") ? (
                              <Link to={"/checkout/" + props.singleEvent.data?.id} className="post-btn">
                                Buy Now
                              </Link>
                            ) : (
                              <Link
                                to={`/signup?redirect=${encodeURIComponent(`/checkout/${props.singleEvent.data?.id}`)}&context=event`}
                                className="post-btn"
                              >
                                Buy Now
                              </Link>
                            )}
                          </div>
                        </div>
                        <p className="event-price-detail mt-2">
                          {props.singleEvent.data?.show_remaining_tickets == 1 &&
                            <span className="text-danger">{props.singleEvent.data?.remaining_tickets > 0 ? props.singleEvent.data?.remaining_tickets + " Tickets Left" : "Sold Out"} </span>
                          }
                        </p>
                      </Card.Body>
                    </Card>

                  </Col>
                </Row>
              ) :
              <Row>
                {/* Left: Event Details */}
                <Col md={12} sm={12} lg={12} xl={12}>
                  <Card className="event-detail-card mb-4">
                    <Card.Body>
                      {t("event_details_not_exist")}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
          }
        </Container>
      </div>
    </>
  );
};

const mapStateToPros = (state) => ({
  singleEvent: state.event.singleEvent,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(EventDetails));
